import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CreditsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "CreditsLinks" */
      './CreditsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
